module.exports = __webpack_public_path__ + "img/Allec-New-Logo-A-Icon.5c1dce98.png";